<template>
	<div>
		<el-dialog 
			:title="title" 
			:visible.sync="showDialogs" 
			append-to-body style="overflow: auto;height: 100%;"
			width="790px" 
			:destroy-on-close="true" 
			:close-on-click-modal="false" 
			@close="closeDialog()">
			<el-form 
				ref="form" 
				:model="formData" 
				label-width="135px" 
				:rules="rules" 
				label-position="top">
				<el-col 
					v-for="(item, index) in formList" 
					:key="index"
					:span="(item.type == 'textarea' || item.type == 'color') ? 22 : 11">
					<el-form-item 
						:prop="item.field" 
						:class="'el-form-item'+'-'+item.field"
						:style="{'width': item.width}" 
						:label="item.label">
						<template v-if="item.type == 'time'">
							<el-date-picker 
								v-model="formData[item.field]" 
								type="datetime" 
								format="yyyy-MM-dd HH:mm:ss"
								class="forminput datecss" 
								placeholder="选择日期时间">
							</el-date-picker>
						</template>
						<template v-else-if="item.type == 'textarea'">
							<el-input 
								v-model="formData[item.field]" 
								type="textarea" 
								style="width: 545px;" 
								:rows="3"
								:autosize="{ minRows: 3}" 
								:placeholder="'请输入'+item.label">
							</el-input>
						</template>
						<template v-else-if="item.type == 'participant'">
							<xh-user-cell
								class="forminput"
								:item="item"
								:index="index"
								:radio="false"
								:value="formData['user_'+item.field]"
								@value-change="arrayValueChange"/>
						</template>
						<template v-else-if="item.type == 'color'">
							<el-input 
								placeholder="请输入内容" 
								v-model="formData[item.field]" 
								class="forminput">
								<i slot="prefix" class="el-input__icon">
									<span class="bg-color" :style="{'background': formData.color}"></span>
								</i>
							</el-input>
							<div class="color-box">
								<span 
									v-for="(item, index) in colorList" 
									:key="index" 
									@click="changeColor(item)"
									:style="{'background': item}">
								</span>
							</div>
						</template>
						<el-input 
							v-else v-model="formData[item.field]" 
							class="forminput"
							:placeholder="'请输入'+item.label"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="22">
					<div style="width: 95px;float: left;height: 20px;"></div>
					<div>
						<related-all v-if="showDialogs" :allData="allData" @checkInfos="checkInfos"></related-all>
					</div>
				</el-col>
			</el-form>
			
			
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">确 定</el-button>
				<el-button @click="closeDialog()">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { XhUserCell } from '@/components/user'
	// 关联业务
	import relatedAll from '@/components/table/relatedAll'
	// API
	import {
		scheduleAdd,
		scheduleEdit
	} from '@/api/index/index'
	export default {
		components: {
			XhUserCell,
			relatedAll
		},
		data() {
			var validateTime = (rule, value, callback) => {
				if (this.formData.start_time && this.formData.end_time) {
					if (
						this.formData.start_time.getTime() >= this.formData.end_time.getTime()
					) {
						callback(new Error('开始时间必须小于结束时间'))
					}
				}
				callback()
			}
			return {
				showDialogs: false,
				formList: [{
						label: '标题',
						field: 'title',
						type: 'color',
					},
					{
						label: '开始时间',
						field: 'start_time',
						type: 'time'
					},
					{
						label: '结束时间',
						field: 'end_time',
						type: 'time'
					},
					{
						label: '参与人',
						field: 'owner_user_ids',
						type: 'participant'
					},
					{
						label: '备注',
						field: 'remark',
						type: 'textarea',
						width: '100%'
					}
				],
				colorList: [
					'#3E8EF7',
					'#11C06C',
					'#0BB2D4',
					'#EB6709',
					'#FF4C52',
					'#526069',
					'#9262F4'
				],
				rules: {
					title: [{
							required: true,
							message: '标题不能为空',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '标题长度最多为50个字符',
							trigger: 'blur'
						}
					],
					start_time: [{
							required: true,
							message: '开始时间不能为空',
							trigger: 'blur'
						},
						{
							validator: validateTime,
							trigger: 'blur'
						}
					],
					end_time: [{
							required: true,
							message: '结束时间不能为空',
							trigger: 'blur'
						},
						{
							validator: validateTime,
							trigger: 'blur'
						}
					]
				},
				// 获取选择的数据id数组
				relevanceAll: {},
				allData: {},
			}
		},
		props: {
			// 控制dialog显示
			showDialog: {
				type: Boolean,
				default: false
			},
			// dialog标题
			title: {
				type: String,
				default: '创建日程'
			},
			// 表单数据
			formData: {
				type: Object,
				default: () => {
					return {
						color: '#3E8EF7'
					}
				}
			}
		},
		mounted() {
			
			
		},
		watch: {
			showDialog: function(value) {
				this.showDialogs = value
				if(value == true){
					// 编辑时引用 - 自动勾选
					this.allData.customer = this.formData.customerList
					  ? this.formData.customerList
					  : []
					this.allData.lawcase = this.formData.lawcaseList
					  ? this.formData.lawcaseList
					  : []
					this.allData.contract = this.formData.contractList
					  ? this.formData.contractList
					  : []
				}
				
				if (this.title == '创建日程') {
					this.$set(this.formData, 'color', '#3E8EF7')
				}
			}
		},
		methods: {
			// 关闭dialog弹窗
			closeDialog() {
				this.$emit('close-dialog')
				this.showDialogs = false
			},

			changeColor(val) {
				this.$set(this.formData, 'color', val)
			},
			
			/**
			 * 参与人
			 */
			arrayValueChange(data) {
				if (data.value.length > 0) {
					let arr = []
					for(let i=0;i<data.value.length;i++){
						arr.push(data.value[i].id)
					}
					this.formData[data.item.field] = arr.join(',')
				} else {
					this.formData[data.item.field] = ''
				}
			},
			
			// 关联业务
			checkInfos(val) {
				this.relevanceAll = val
			},

			// 提交
			submit() {
				this.$refs.form.validate(valid => {
					if (valid) {
						let data = this.formData
						let owner_user_ids = []
						
						if (this.title == '创建日程') {
							scheduleAdd({
									title: data.title,
									start_time: data.start_time,
									end_time: data.end_time,
									owner_user_ids: data.owner_user_ids,
									remark: data.remark,
									color: data.color,
									customer_ids: this.relevanceAll.customer_ids,
									lawcase_ids: this.relevanceAll.lawcase_ids,
									contract_ids: this.relevanceAll.contract_ids
								})
								.then(res => {
									if (this.$route.query.routerKey == 1) {
										this.$router.push('schedule')
									} else {
										this.$emit('onSubmit')
									}
									this.loading = false
								})
								.catch(err => {
									this.loading = false
								})
						} else {
							
							let list = {
								customer_ids: [],
								contract_ids: [],
								lawcase_ids: []
							}
							// 客户
							if (this.allData.customer) {
								for (let item of this.allData.customer) {
									list.customer_ids.push(item.id)
								}
							}
							// 案件
							if (this.allData.lawcase) {
								for (let item of this.allData.lawcase) {
									list.lawcase_ids.push(item.id)
								}
							}
							// 合同
							if (this.allData.contract) {
								for (let item of this.allData.contract) {
									list.contract_ids.push(item.id)
								}
							}
							
							let ids =
								JSON.stringify(this.relevanceAll) == '{}' ?
								list :
								this.relevanceAll
							scheduleEdit({
									event_id: data.id,
									title: data.title,
									start_time: data.start_time,
									end_time: data.end_time,
									owner_user_ids: data.owner_user_ids,
									remark: data.remark,
									color: data.color,
									customer_ids: ids.customer_ids,
									lawcase_ids: ids.lawcase_ids,
									contract_ids: ids.contract_ids
								})
								.then(res => {
									this.$emit('onSubmit')
									this.loading = false
								})
								.catch(err => {
									this.loading = false
								})
						}
					} else {
						return false
					}
				})
			}
		},
	}
</script>
<style scoped lang="scss">
	.forminput {
		width: 200px;
	}

	/deep/ .el-dialog {
		overflow: auto;
	}

	/deep/ .el-dialog__body {
		overflow: auto;
	}

	.forminput {
		width: 200px;
	}

	/deep/ .el-form-item__content {
		display: inline-block;
		line-height: 40px;
		width: 200px;
	}

	/deep/ .el-input__inner {
		height: 40px;
		line-height: 40px;
		outline: none;
		padding: 0 25px;
	}

	/deep/ .el-form--label-top .el-form-item__label {
		padding: 0 10px 0 0;
	}

	/deep/ .el-form-item {
		margin-bottom: 23px !important;
		position: relative;
	}

	/deep/ .el-form-item__label {
		text-align: left !important;
		vertical-align: middle !important;
		float: left;
		font-size: 13px;
		color: #606266;
		line-height: 40px !important;
		padding: 0 12px 0 0;
		box-sizing: border-box;
		width: 95px !important;
	}

	/deep/ .el-form-item__content {
		width: auto !important;
	}

	/deep/ .el-textarea__inner {
		/* min-height: 40px !important; */
		line-height: 30px !important;
		padding: 5px 15px !important;
	}

	.el-col-11 {
		/* height: 100px; */
	}

	.datecss /deep/ .el-input__inner {
		padding: 0 15px 0 25px !important;
	}

	.card-base {
		border-left: 5px solid #3A8EE6;
		height: 15px;
		padding-left: 10px;
		margin: 0 0 20px 0
	}

	.color-box {
		margin-top: 10px;
		line-height: normal;

		span {
			display: inline-block;
			width: 18px;
			height: 18px;
			margin-right: 25px;
			border-radius: 50%;
			cursor: pointer;
		}

		span:last-child {
			margin: 0;
		}
	}

	.bg-color {
		width: 15px;
		height: 15px;
		border-radius: 50%;
		display: inline-block;
		vertical-align: middle;
	}

	.el-input__prefix {
		margin-top: 3px;
		margin-left: 3px;
	}
</style>